import React from 'react'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import TypographyAtom from '../typography/typography.atom'
import internal_server_errorStyles from './not_found.styles'
import SvgIconAtom from '../svg_icon/svg_icon.atom'

const apAtomName = {ap_atom_name: 'apNotFoundAtom'}

const StyledWrapper = styled(props => <section {...props} />)`
  ${internal_server_errorStyles}
`

const NotFoundAtom: React.FC = function () {
  const {t} = useTranslation()

  return (
    <StyledWrapper {...apAtomName}>
      <div>
        <SvgIconAtom ap_type="notFound" />
      </div>
      <div>
        <TypographyAtom ap_type="h4">{404}</TypographyAtom>
        <TypographyAtom ahd_type="fData">
          {t('notFoundPage.description')}
        </TypographyAtom>
      </div>
    </StyledWrapper>
  )
}

export default NotFoundAtom
